// tslint:disable:only-arrow-functions
import { IDynamicItem } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

export function getProductCardIcons(): IDynamicItem {
  return {
    id: 'product-card-icons',
    contentTypeId: 'dynamic-elements-product-card-icons',
    styles: {
      style: {
        bottom: '0',
        left: '0',
        right: '0',
        padding: '0 3px 2px 3px',
      },
      classes: ['position-absolute', 'bg-white'],
      variables: {
        '--p-card-icon-color':
          'var(--color-brand-muted, var(--color-brand-gray-800, #777777))',
        '--color-brand-muted': 'var(--color-brand-gray-800, #777777)',
      },
    },
    inputs: {
      product: {
        provider: 'parent',
        property: 'productData',
        transform: function ({
          product,
        }: {
          product: {
            earliestAvailableDate: string;
            attributes: { [key: string]: [{ value: string }] };
            metaData: { [key: string]: string };
          };
        }) {
          const value = {
            ...product,
            attributes: Object.entries(product.attributes).reduce(
              (acc, [key, val]) => {
                if (Array.isArray(val)) {
                  const firstItem = val[0];

                  if (
                    firstItem &&
                    typeof firstItem === 'object' &&
                    'value' in firstItem
                  ) {
                    // Old format: [{ value: "..." }]
                    acc[key] = (firstItem as { value: string }).value;
                  } else if (typeof firstItem === 'string') {
                    // New format: ["..."]
                    acc[key] = firstItem;
                  }
                } else if (typeof val === 'string') {
                  acc[key] = val;
                }

                return acc;
              },
              {} as { [key: string]: string },
            ),
            earliestAvailableDate:
              product.earliestAvailableDate ??
              product.metaData?.earliestAvailableDate,
          };
          return value;
        }.toString(),
      },
      showGenderIcon: true,
      showMraIcon: false,
      showPopularityIcon: false,
    },
    if: [
      'EQ',
      [{ provider: 'id:root', property: 'showProductCardIcons' }, true],
    ],
  };
}
